export const selectInaccessibleMailboxesRaw = state =>
  state.mailboxes.inaccessibleMailboxes
